import produce from 'immer';
import { atom } from 'recoil';
import reducerSelector from '../utils/reducerSelector';

export const LOADING_LIST_DSP = 'LOADING_LIST_DSP';
export const LOADED_LIST_DSP = 'LOADED_LIST_DSP';
export const ADD_COURIER_SUCCESS = 'ADD_COURIER_SUCCESS';
export const UPDATE_TOTAL_DRIVER_DSP_LIST = 'UPDATE_TOTAL_DRIVER_DSP_LIST';

export const dspAtom = atom({
  key: 'dspAtom',
  default: {
    page: 0,
    size: 20,
    items: [],
    order_by: 'id',
    desc: true,
    total: 0,
    isListing: false,
    q: '',
  },
});
export const dspReducer = (state, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case LOADING_LIST_DSP: {
        draft.isListing = true;
        break;
      }
      case LOADED_LIST_DSP: {
        draft.isListing = false;
        Object.entries(action.data).forEach(([k, v]) => {
          draft[k] = v;
        });
        Object.entries(action.params).forEach(([k, v]) => {
          draft[k] = v;
        });
        break;
      }
      case ADD_COURIER_SUCCESS: {
        draft.items = [action.data, ...state.items];
        draft.total += 1;
        break;
      }
      case UPDATE_TOTAL_DRIVER_DSP_LIST: {
        const { courierId, isAdded } = action.payload;
        const { items } = state;
        const targetIndex = items.findIndex((item) => item.id === parseInt(courierId, 10));
        if (targetIndex > -1) {
          if (isAdded) {
            draft.items[targetIndex].totalDriver += 1;
          } else {
            draft.items[targetIndex].totalDriver -= 1;
          }
        }
        break;
      }
      default:
        throw new Error();
    }
  });
export const dspSelector = reducerSelector({
  selectorKey: 'dspSelector',
  reducer: dspReducer,
  selectorAtom: dspAtom,
});

export const dspDrivers = atom({
  key: 'dsp_driver',
  default: {
    page: 0,
    size: 20,
    items: [],
    order_by: 'id',
    desc: true,
    total: 0,
    isListing: false,
    q: '',
  },
});
